import { defineStore } from 'pinia'
import { hemocultureApi, type HemocultureUser } from '../services/hemoculture-api'

const TOKEN_KEY = 'hemoculture-token'

export const useHemocultureAuthStore = defineStore('hemoculture-auth', {
  state: () => ({
    user: null as HemocultureUser | null,
    token: localStorage.getItem(TOKEN_KEY) ?? '',
    isLoading: false,
  }),

  getters: {
    isAuthenticated: (state) => Boolean(state.token),
    isAdmin: (state) => state.user?.is_admin === true,
    laboratoryId: (state) => state.user?.laboratory?.id ?? null,
  },

  actions: {
    setToken(token: string) {
      this.token = token
      localStorage.setItem(TOKEN_KEY, token)
    },

    clearSession() {
      this.user = null
      this.token = ''
      localStorage.removeItem(TOKEN_KEY)
    },

    async login(email: string, password: string) {
      this.isLoading = true
      try {
        const { token, user } = await hemocultureApi.login(email, password)
        this.setToken(token)
        this.user = user
      } finally {
        this.isLoading = false
      }
    },

    async fetchCurrentUser() {
      if (!this.token) return null
      const { user } = await hemocultureApi.me()
      this.user = user
      return user
    },

    async logout() {
      try {
        await hemocultureApi.logout()
      } catch {
        /* ignore */
      }
      this.clearSession()
    },
  },
})
